module.exports = __webpack_public_path__ + "media/images/recruit/environments/ph_08-d9fa27eea97691d9565edd22c274a252.jpg";